import React, {useState} from 'react';
import './App.css';
import SceneSelector from './components/SceneSelector';

import Hintergrund1 from './hintergrund';
import Hintergrund2 from './hintergrund2';
import Hintergrund3 from './hintergrund3';
import Hintergrund4 from './hintergrund4';
import Hintergrund5 from './hintergrund5';
import Hintergrund6 from './hintergrund6';
import Hintergrund7 from './hintergrund7';
import Hintergrund8 from './hintergrund8';

const scenes = [
    { name: 'h1', label: 'Fat Line' },
    { name: 'h2', label: 'Ellipse' },
    { name: 'h3', label: 'Ellipse Collection' },
    { name: 'h4', label: 'Sinus Particles' },
    { name: 'h5', label: 'Noise Particles' },
    { name: 'h6', label: 'Nebel' },
    { name: 'h7', label: 'Final Scene' },
    { name: 'h8', label: 'Galaxy' },
];

function App() {
    const [active, setActive] = useState('h7');

    const renderScene = () => {
        switch (active) {
            case 'h1': return <Hintergrund1 />;
            case 'h2': return <Hintergrund2 />;
            case 'h3': return <Hintergrund3 />;
            case 'h4': return <Hintergrund4 />;
            case 'h5': return <Hintergrund5 />;
            case 'h6': return <Hintergrund6 />;
            case 'h7': return <Hintergrund7 />;
            case 'h8': return <Hintergrund8 />;
            default: return null;
        }
    };

    return (
      <div className="App">

          <SceneSelector scenes={scenes} current={active} onSelect={setActive} />
          {renderScene()}

         <header className="App-header">
              <h1>Willkommen auf meiner Seite!</h1>
         </header>
      </div>
  );
}

export default App;